import script from "./BlockSplitBar.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockSplitBar.vue?vue&type=script&setup=true&lang=js"

import "./BlockSplitBar.vue?vue&type=style&index=0&id=266d63cf&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-266d63cf"]])

export default __exports__